import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { LogoutComponent } from './shared-components/logout/logout.component';
import { CallbackComponent } from './shared-modules/login/callback/callback.component';
import { ChangePasswordComponent } from './shared-modules/login/change-password/change-password.component';
import { LoginAssistComponent } from './shared-modules/login/login-assist/login-assist.component';
import { LoginComponent } from './shared-modules/login/login.component';
import { SilentcallbackComponent } from './shared-modules/login/silentcallback/silentcallback.component';

const appRoutes: Routes = [
    { path: 'loginAssist', component: LoginAssistComponent },
    { path: 'loginassist', component: LoginAssistComponent },
    { path: 'login', component: LoginComponent },
    { path: 'callback', component: CallbackComponent },
    { path: 'silentcallback', component: SilentcallbackComponent },
    { path: 'parent', component: LoginComponent },
    { path: 'student', component: LoginComponent },
    { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard] },
    {
        path: 'familyregistration',
        loadChildren: () => import('app/shared-modules/family-registration/family-registration.module').then(m => m.FamilyRegistrationModule)
    },
    {
        path: 'studentattachment',
        loadChildren: () => import('app/shared-modules/student-attachment/student-attachment.module').then(m => m.StudentAttachmentModule)
    },
    {
        path: 'classroom360',
        loadChildren: () => import('app/classroom360/classroom360.module').then(m => m.Classroom360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'student360',
        loadChildren: () => import('app/student360/student360.module').then(m => m.Student360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'counselor360',
        loadChildren: () => import('app/counselor360/counselor360.module').then(m => m.Counselor360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin360',
        loadChildren: () => import('app/admin360/admin360.module').then(m => m.Admin360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'statereporting',
        loadChildren: () => import('app/state-reporting/state-reporting.module').then(m => m.StateReportingModule),
        // canActivate: [AuthGuard]
    },
    {
        path: 'management360',
        loadChildren: () => import('app/management360/management360.module').then(m => m.Management360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'health360',
        loadChildren: () => import('app/health360/health360.module').then(m => m.Health360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'sped360',
        loadChildren: () => import('app/sped360/sped360.module').then(m => m.Sped360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'specialServiceEvaluations',
        loadChildren: () => import('app/special-service-evaluations/special-service-evaluations.module').then(m => m.SpecialServiceEvaluationsModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'utilities360',
        loadChildren: () => import('app/utilities360/utilities360.module').then(m => m.Utilities360Module),
        canActivate: [AuthGuard]
    },
    {
        path: 'changePassword',
        component: ChangePasswordComponent
    },
    {
        path: 'tylerU',
        loadChildren: () => import('app/shared-modules/tyler-u/tyler-u.module').then(m => m.TylerUModule)
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
                onSameUrlNavigation: 'reload',
                relativeLinkResolution: 'legacy',
                anchorScrolling: 'enabled'
            }
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {

}
